import React from "react";
import TableDetailRow from "MODULES/shared/components/DetailTable/Detail";
import T from "prop-types";
import { properCase } from "LIB/formatters/text";
import {
  APPROVED,
  REJECTED,
  TRACE_HOLD,
  TRACE_HOLD_APPROVED
} from "MODULES/PurchaseOrders/constants";
import AuditedNoteTooltip from "MODULES/shared/components/NoteTooltip/AuditedNoteTooltip";

export function TraceHoldDetail({ purchaseOrder }) {
  if (
    purchaseOrder.trace_hold === null ||
    purchaseOrder.trace_hold_approved === null
  )
    return null;

  return (
    <table className="table table-condensed">
      <tbody>
        <TableDetailRow
          label={properCase(TRACE_HOLD)}
          value={[
            purchaseOrder.trace_hold_approved
              ? properCase(APPROVED)
              : properCase(REJECTED),
            <AuditedNoteTooltip
              field={TRACE_HOLD_APPROVED}
              obj={Object.assign(purchaseOrder, {
                [TRACE_HOLD_APPROVED]: TRACE_HOLD_APPROVED ? APPROVED : REJECTED
              })}
            />
          ]}
        />
      </tbody>
    </table>
  );
}

TraceHoldDetail.propTypes = {
  purchaseOrder: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/TraceHoldDetails.jsx